import { makeStyles } from '@material-ui/core';
import { PORTAL_BRAND_TOKENS } from '../../theme/portalTheme';
import { HIPER_SAUDE_LOGO } from './logoAsset';

const useStyles = makeStyles({
  // Versão compacta (sidebar recolhida): mesmo chip branco, menor.
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PORTAL_BRAND_TOKENS.color.surface,
    borderRadius: PORTAL_BRAND_TOKENS.shape.borderRadius,
    padding: 4,
  },
  img: {
    display: 'block',
    height: 28,
    width: 28,
    objectFit: 'contain',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <span className={classes.chip}>
      <img
        className={classes.img}
        src={HIPER_SAUDE_LOGO}
        alt="Grupo Hiper Saúde"
      />
    </span>
  );
};
